import { createContext } from 'react';

export const PatientIvContext = createContext(null!);
